import React from 'react';

import { PRICING_PLANS } from '../../data/pricing';
import { PricingCard } from './PricingCard';

/**
 * PricingSection Component
 * 
 * Displays pricing plans with glassmorphic cards.
 * 
 * Exact styles from landing.css:
 * - Plan cards: min-width 250px, max-width 300px
 * - Flex layout with wrap and center
 * - Plan price: 2.5rem (40px)
 * - Features list with checkmarks
 * - Buttons: full width, 48px min height
 */
const PricingSection = () => {
  return (
    <section id="plans" className="section py-section-mobile md:py-section-tablet lg:py-section-desktop px-4 md:px-6 lg:px-8 max-w-[1200px] mx-auto relative z-10">
      <h2 className="section-title text-center text-mobile-section-title md:text-2xl lg:text-section-title font-medium mb-6 md:mb-10 lg:mb-12 text-text-primary leading-tight md:leading-normal">
        Pricing Plans
      </h2>

      {/* Plans Grid - MOBILE: Mobile-first spacing */}
      <div className="pricing-container">
        {/* Top Row: Basic, Pro, Premium */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 lg:gap-8 mb-6 md:mb-8">
          {PRICING_PLANS.slice(0, 3).map(plan => (
            <PricingCard key={plan.id} plan={plan} />
          ))}
        </div>

        {/* Bottom Row: Organization, Enterprise - Centered */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 lg:gap-8 max-w-[700px] mx-auto">
          {PRICING_PLANS.slice(3, 5).map(plan => (
            <PricingCard key={plan.id} plan={plan} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;

